module.exports = __webpack_public_path__ + "media/images/lp/1/voice4-open-28447fefd58685476ec37b959267b73a.png";